import Icon from './src/icon'

export default Icon


// WEBPACK FOOTER //
// ./src/components/tofu-icon/index.js